import { lazy, Suspense } from "react";

import { useAuth } from "./auth/AuthContext";
import AccessDeniedPage from "./components/AccessDeniedPage";

const ModelingApp = lazy(() => import("./ModelingApp"));

function RouteLoading() {
  return (
    <div className="route-loading" role="status">
      Loading workspace…
    </div>
  );
}

export default function App() {
  const auth = useAuth();
  if (!auth.canViewAnalyst && !auth.canOperate) return <AccessDeniedPage />;

  return (
    <Suspense fallback={<RouteLoading />}>
      <ModelingApp />
    </Suspense>
  );
}
